import { queryClient } from '../../../ReactQuery';
import useToastedMutation from '../../../ReactQuery/useToastedMutation';
import { post } from '../../../redux/api';
import { nuc } from '../../../utils';
import type { SnippetsFilterParams } from '../../../../shared/snippets';

import { getSnippetByIdQueryKey, getSnippetsBaseQueryKey } from './shared';

function unrejectSnippets(userRevisionLocator: string, params: SnippetsFilterParams) {
  return post(`/api/revisions/${nuc(userRevisionLocator)}/snippets/unreject`, params);
}

/**
 * Allow users of this hook to specify additional query keys to invalidate.
 */
export type UnrejectSnippetsInvalidationOptions = {
  revisionLocator?: string;
  id?: string;
};

/**
 * useUnrejectSnippets is a hook that unrejects snippets.
 */
export default function useUnrejectSnippets(
  userRevisionLocator: string,
  { revisionLocator, id }: UnrejectSnippetsInvalidationOptions = {},
) {
  return useToastedMutation({
    mutationFn: (params: SnippetsFilterParams) => unrejectSnippets(userRevisionLocator, { ...params, path: params.path ?? '/' }),
    onSuccess: () => {
      // Invalidate (and refetch) the snippets for this user revision locator.
      queryClient.invalidateQueries(getSnippetsBaseQueryKey(userRevisionLocator));
      if (revisionLocator) {
        queryClient.invalidateQueries({ queryKey: getSnippetsBaseQueryKey(revisionLocator) });
      }
      if (id) {
        queryClient.invalidateQueries({ queryKey: getSnippetByIdQueryKey(userRevisionLocator, id) });
      }
    },
    successToastMessage: 'Snippet(s) unrejected successfully.',
    errorToastMessage: 'Failed to unreject snippet(s).',
  });
}
